
import './Teenused.css';
import {useState, useEffect} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import { Button, Navbar, Container, Nav, NavDropdown, Card, Row, Col, Image, Table, ThemeProvider } from 'react-bootstrap';

export default function Hero() {

    return (
      
        <div className='main'>
            <Container>
                <h1 style={{marginBottom:"2.5rem"}}><strong>Meeskond</strong></h1>
                <div style={{display:"flex", justifyContent:"center", marginBottom:"2.5rem", flexDirection:"column"}}>
                    <div style={{display:"flex", justifyContent:"center", width:"100%"}}>
                        <p style={{fontWeight:"500", width:"900px", textAlign:"start"}}>

                            Dr Riina Einblau - hambaarst - ortodont<br></br>
                            Alla Grisina - hambaravi õde<br></br>
                            Roosi Järvinen – hambaravi assistent<br></br>
                            Sven Einblau - sterilisatsioonitehnik
                        </p>
                    </div>
                </div>
                
            </Container>
        </div>
    );
}